import { render, staticRenderFns } from "./PatientRegistration.vue?vue&type=template&id=76ae7503&scoped=true&"
import script from "./PatientRegistration.vue?vue&type=script&lang=js&"
export * from "./PatientRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PatientRegistration.vue?vue&type=style&index=0&id=76ae7503&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ae7503",
  null
  
)

export default component.exports